export default __webpack_public_path__ + "static/media/hardware_arcade.39b5580c.svg";